module.exports = __webpack_public_path__ + "static/media/Vrachtwagen.70f0e88d.mp3";